import React from 'react';

const DoctorBusinessAdmin = () => {
  return (
    <div className="container mx-auto p-6">
      <div className="bg-white shadow-md rounded-lg p-6 mb-6">
        <h2 className="text-3xl font-bold mb-4">Doctor of Business Administration (DBA)</h2>
        <p className="mb-4" align="justify">
          The <strong>Doctor of Business Administration (DBA)</strong> degree is an interdisciplinary professional
          degree at the highest level of formal study in administration and business. It is intended to develop the breadth and depth of
          comprehension, the command of research methods and the understanding of related disciplines. The requirements for the degree include 45 or
          more credit hours.
        </p>
        <p className="mb-4" align="justify">
          The degree provides students with the means to explore personal readiness to become leaders in the business and
          management professions. Students gain a mastery of business administration literature and demonstrate competence by applying this
          knowledge to current local, national and international environments.
        </p>
        <p className="mb-4" align="justify">
          Upon completion of this degree, our students have advanced knowledge in the areas of their specialization and the
          capability of implementing such knowledge. This degree is mainly for practitioners - executives, managers and consultants in business,
          government and non-profit organizations. It offers practical concentration in Executive Leadership and Management, Organizational
          Behavior and Development, and Marketing.
        </p>
      </div>
    </div>
  );
};

export default DoctorBusinessAdmin;